import type { DSContentConnectorSize } from "@/src/design_system/primitives/content_connector/types";
import { DS_CONTENT_CONNECTOR_SIZES } from "@/src/design_system/primitives/content_connector/types";

export const DS_CONTENT_CONNECTOR_CLASSES = {
  Base: "ds-content-connector",
  SizeMedium: "ds-content-connector--md",
  SizeLarge: "ds-content-connector--lg",
} as const;

export const DS_CONTENT_CONNECTOR_SIZE_TO_CLASS_MAP: Record<DSContentConnectorSize, string> = {
  [DS_CONTENT_CONNECTOR_SIZES.Medium]: DS_CONTENT_CONNECTOR_CLASSES.SizeMedium,
  [DS_CONTENT_CONNECTOR_SIZES.Large]: DS_CONTENT_CONNECTOR_CLASSES.SizeLarge,
};
